/*
 * Sepet sözleşme onayı — norm-shopify/sozlesme (dört marka teması ve Tivessa için aynı dosya).
 *
 * Kutunun kendisi `required`: JS çalışmasa da işaretlenmeden sepet formu ödemeye gönderilmez. Bu dosya üstüne
 * dört şey ekler: tarayıcının kendi balonu yerine açık bir uyarı, onay kaydına zaman damgası, sepet değişince
 * eski onay kaydının silinmesi ve iki belgeyi sepetten ayrılmadan açan pencere. Olay dinleyicileri belgeye
 * bağlı: çekmece yeniden çizilse de çalışır.
 */
(() => {
  if (window.normSozlesme) return;
  window.normSozlesme = true;

  const KUTU = '[data-norm-sozlesme-kutu]';
  let bekleyenSilme = null;                    // sepet değişince giden onay silme isteği (aşağıda)
  const english = () => (document.documentElement.lang || '').toLowerCase().startsWith('en');

  const kutuBul = (form) => form && Array.from(form.elements || []).find((el) => el.matches && el.matches(KUTU));

  const uyar = (kutu, goster) => {
    const kap = kutu.closest('[data-norm-sozlesme]');
    if (!kap) return;
    kap.classList.toggle('norm-sozlesme--hata', goster);
    const uyari = kap.querySelector('[data-norm-sozlesme-uyari]');
    if (uyari) uyari.hidden = !goster;
    if (goster) {
      kap.scrollIntoView({ block: 'center', behavior: 'smooth' });
      kutu.focus({ preventScroll: true });
    }
  };

  // Kutu işaretli değilken tarayıcı formu durdurur ve `invalid` olayını verir (kabarcıklanmaz: capture).
  document.addEventListener('invalid', (event) => {
    if (!event.target.matches || !event.target.matches(KUTU)) return;
    event.preventDefault();
    uyar(event.target, true);
  }, true);

  document.addEventListener('change', (event) => {
    if (event.target.matches && event.target.matches(KUTU) && event.target.checked) uyar(event.target, false);
  });

  // Ödemeye geçerken: `novalidate` bir form kutuyu atlamasın; işaretliyse onay kaydının başına zamanı yaz.
  document.addEventListener('submit', (event) => {
    const submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout') return;
    const kutu = kutuBul(event.target);
    if (!kutu) return;
    if (!kutu.checked) {
      event.preventDefault();
      event.stopImmediatePropagation();
      uyar(kutu, true);
      return;
    }
    if (bekleyenSilme) {                       // silme, formun yazacağı onaydan sonra varmasın
      event.preventDefault();
      event.stopImmediatePropagation();
      const form = event.target;
      bekleyenSilme.then(() => form.requestSubmit(submitter));
      return;
    }
    if (!kutu.dataset.normTaban) kutu.dataset.normTaban = kutu.getAttribute('value') || '';
    kutu.value = `${new Date().toISOString().replace(/\.\d{3}Z$/, 'Z')} · ${kutu.dataset.normTaban}`;
  }, true);

  // Sepet değişince eski onay siparişe taşınmasın. Sepet özniteliği sepet boşalsa bile kalır (/cart/clear ürünleri
  // siler, öznitelikleri silmez). Bu yüzden ürün eklenince, çıkarılınca, adedi ya da indirimi değişince onay kaydı da
  // silinir. Form yoluyla ödemeye geçen alıcı kutuyu yeniden işaretler (bölüm yeniden çizilince kutu boş gelir).
  // Formsuz yoldan (elle /checkout, kalıcı bağlantı) geçen alıcının siparişinde onay olmaz ve Flow bunu bildirir.
  // Onayı kendisi taşıyan istek (ödemeye geçerken formu gönderen tema) dokunulmadan geçer.
  const SEPETI_DEGISTIREN = /\/cart\/(add|change|update|clear)(\.js)?$/;
  // Sepet boşken sayfada kutu yoktur; ad o zaman buradan gelir (markalar.py ONAY_ANAHTARI, Flow ve e-posta da bunu okur).
  const ONAY_ANAHTARI = 'Sözleşme onayı';
  const onayAnahtari = () => {
    const kutu = document.querySelector(KUTU);
    const m = kutu && /^attributes\[(.+)\]$/.exec(kutu.name);
    return m ? m[1] : ONAY_ANAHTARI;
  };
  const onayiTasiyor = (govde, anahtar) => {
    if (!govde) return false;
    if (typeof govde === 'string') return govde.includes(anahtar) || govde.includes(encodeURIComponent(anahtar));
    if (typeof govde.keys === 'function') return Array.from(govde.keys()).some((k) => String(k).includes(anahtar));
    return false;
  };
  const ozgunFetch = window.fetch;
  if (typeof ozgunFetch === 'function') {
    window.fetch = function (girdi, ayar) {
      const istek = ozgunFetch.apply(this, arguments);
      try {
        const anahtar = onayAnahtari();
        const adres = new URL(typeof girdi === 'string' || girdi instanceof URL ? girdi : girdi.url, window.location.href);
        if (anahtar && adres.origin === window.location.origin && SEPETI_DEGISTIREN.test(adres.pathname)
            && !onayiTasiyor(ayar && ayar.body, anahtar)) {
          istek.then((yanit) => {
            if (!yanit.ok) return;
            const silme = ozgunFetch.call(window, `${window.Shopify?.routes?.root || '/'}cart/update.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ attributes: { [anahtar]: '' } }),
            }).catch(() => {}).then(() => { if (bekleyenSilme === silme) bekleyenSilme = null; });
            bekleyenSilme = silme;
          }).catch(() => {});
        }
      } catch (hata) { /* adres çözülemezse dokunma */ }
      return istek;
    };
  }

  // Belgeler: sepetle doldurulmuş /cart?view=sozlesme sayfasından alınır, pencerede gösterilir.
  let pencere;
  const pencereyiKur = () => {
    if (pencere) return pencere;
    pencere = document.createElement('dialog');
    pencere.className = 'norm-sozlesme-pencere';
    pencere.setAttribute('aria-label', english() ? 'Contract documents' : 'Sözleşme belgeleri');
    pencere.innerHTML = `<div class="norm-sozlesme-pencere__ust"><button type="button" class="norm-sozlesme-pencere__kapat">${english() ? 'Close' : 'Kapat'}</button></div><div class="norm-sozlesme-pencere__icerik" tabindex="-1"></div>`;
    pencere.querySelector('.norm-sozlesme-pencere__kapat').addEventListener('click', () => pencere.close());
    pencere.addEventListener('click', (event) => { if (event.target === pencere) pencere.close(); });
    document.body.appendChild(pencere);
    return pencere;
  };

  document.addEventListener('click', async (event) => {
    const link = event.target.closest && event.target.closest('[data-norm-sozlesme-ac]');
    if (!link || typeof HTMLDialogElement !== 'function') return;
    const kap = link.closest('[data-norm-sozlesme]');
    const url = kap && kap.dataset.normBelgelerUrl;
    if (!url) return;
    event.preventDefault();
    const d = pencereyiKur();
    const icerik = d.querySelector('.norm-sozlesme-pencere__icerik');
    icerik.innerHTML = `<p class="norm-sozlesme-pencere__bekle">${english() ? 'Loading…' : 'Yükleniyor…'}</p>`;
    if (!d.open) d.showModal();
    try {
      const yanit = await fetch(url, { credentials: 'same-origin' });
      if (!yanit.ok) throw new Error(String(yanit.status));
      const sayfa = new DOMParser().parseFromString(await yanit.text(), 'text/html');
      const belgeler = sayfa.querySelector('[data-norm-sozlesme-belgeler]');
      if (!belgeler) throw new Error('belge yok');
      belgeler.querySelector('.norm-sozlesme-belgeler__geri')?.remove();
      icerik.replaceChildren(document.importNode(belgeler, true));
      const hedef = icerik.querySelector(`#${link.dataset.normSozlesmeAc}`);
      if (hedef) hedef.scrollIntoView({ block: 'start' }); else icerik.scrollTop = 0;
      icerik.focus({ preventScroll: true });
    } catch (error) {
      d.close();
      window.location.assign(link.href);       // pencere açılamazsa belgeler kendi sayfasında
    }
  });

  // Pencerenin içindeki iki belge birbirine çapa ile bağlanır; sayfa kaymasın, pencere içinde gidilsin.
  document.addEventListener('click', (event) => {
    const link = event.target.closest && event.target.closest('.norm-sozlesme-pencere a[href^="#norm-"]');
    if (!link) return;
    const hedef = pencere && pencere.querySelector(link.getAttribute('href'));
    if (!hedef) return;
    event.preventDefault();
    hedef.scrollIntoView({ block: 'start', behavior: 'smooth' });
  });
})();
